export function getErrorMessage(err: any): string {
  if (err?.formattedError) return err.formattedError;
  if (err?.response?.data?.message) return err.response.data.message;
  if (err?.response?.status) {
    const statusText = err.response.statusText ? ` ${err.response.statusText}` : '';
    return `Request failed with status ${err.response.status}${statusText}`;
  }
  if (err?.status) return `Request failed with status ${err.status}`;
  if (err?.code) return `Request failed (${err.code})`;
  if (err?.message) return err.message;
  return 'An unexpected error occurred.';
}
